define('formkit/behavior/inline.validations.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _  = require('underscore');
  var Mn = require('marionette');

  var InlineValidationsBehavior = Mn.Behavior.extend({

    defaults: {
      validationMode: 'inline'
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        switch (this.getOption('validationMode')) {
          case 'inline':
          this.enableInlineValidations();
          break;
        }
      })
    },

    enableInlineValidations: function() {
      var form = this.getOption('form') || this.view.form;

      this.endEditAnswerEventOptions = [];
      this.listenTo(form, 'end:edit:answer', function(templateObjectModel, options) {
        if (_.result(options, 'templateObjectModel')
        && _.result(options, 'answerValueModel')
        && _.result(options, 'formObjectView')
        && !_.result(options, 'triggeredByNewAnswerValueModel')) {
          this.endEditAnswerEventOptions.push(options);
        }
      });
      this.listenTo(form.getTemplateModel(), 'sync', function() {
        var options, formObjectView;
        while (options = this.endEditAnswerEventOptions.pop()) {
          formObjectView = options.formObjectView;
          formObjectView.formObjectState.showFailedValidations(options.answerValueModel, options.templateObjectModel);
        }
      });
    }
  });
  module.exports = InlineValidationsBehavior;
});

